import { FC } from 'react';

import { Cell, CellText, VSpacing } from '@hh.ru/magritte-ui';
import { TrashOutlinedSize16 } from '@hh.ru/magritte-ui/icon';

import useOnOffState from 'hooks/common/useOnOffState';

import { AiIcon } from 'components/common/BannerImg/GalleryModal/AiIcon/AiIcon';
import { WarningModal } from 'components/common/BannerImg/GalleryModal/Image/WarningModal/WarningModal';

import styles from 'components/common/BannerImg/GalleryModal/Image/Image.module.less';

interface ImageProps {
    id: number;
    imageWidth: number;
    imageHeight: number;
    url: string;
    onClick: () => void;
    userLoadedImages: boolean;
    isAi: boolean;
}

export const Image: FC<ImageProps> = ({
    id,
    imageWidth,
    imageHeight,
    url,
    onClick,
    userLoadedImages = false,
    isAi,
}) => {
    const [isWarningModalVisible, setIsWarningModalVisibleOn, setIsWarningModalVisibleOff] = useOnOffState(false);

    return (
        <div>
            <div className={styles.imageContainer}>
                <img className={styles.image} src={url} onClick={onClick} data-qa={`gallery-image-${id}`} />
                {isAi && (
                    <div className={styles.imageAi}>
                        <AiIcon />
                    </div>
                )}
            </div>
            {userLoadedImages && (
                <>
                    <VSpacing default={8} />
                    <Cell
                        align="center"
                        right={<TrashOutlinedSize16 initialColor="secondary" onClick={setIsWarningModalVisibleOn} />}
                    >
                        <CellText style="secondary">
                            {imageWidth} &times; {imageHeight}
                        </CellText>
                    </Cell>
                </>
            )}
            <WarningModal visible={isWarningModalVisible} onClose={setIsWarningModalVisibleOff} id={id} />
        </div>
    );
};
